(function(){
  'use strict';
  
  let unlocked = false;
  
  const unlockVideos = () => {
    if (unlocked) return;
    unlocked = true;

    document.querySelectorAll('.how_to_use_sec video.lazyvid').forEach(tryPlay);
    
    document.removeEventListener('touchstart', unlockVideos, true);
    document.removeEventListener('pointerdown', unlockVideos, true);
  };

  const setInlineAttrs = (v) => {
    v.muted = true;
    v.defaultMuted = true;
    v.autoplay = true;
    v.loop = true;
    v.playsInline = true;
    v.preload = 'auto';
    
    v.setAttribute('muted', '');
    v.setAttribute('autoplay', '');
    v.setAttribute('loop', '');
    v.setAttribute('playsinline', '');
    v.setAttribute('webkit-playsinline', '');
  };

  const attachSource = (v, src) => {
    v.querySelectorAll('source').forEach(s => s.remove());
    const s = document.createElement('source');
    s.src = src;
    s.type = 'video/mp4';
    v.appendChild(s);
  };

  const tryPlay = (v) => {
    setInlineAttrs(v);
    const p = v.play();
    if (p && p.catch) p.catch(() => {});
  };

  const loadVid = (v) => {
    if (v.dataset.loaded) return;
    const src = v.dataset.src;
    if (!src) return;

    v.dataset.loaded = '1';
    attachSource(v, src);
    v.load();
    tryPlay(v);

    const onReady = () => tryPlay(v);
    v.addEventListener('loadedmetadata', onReady, { once: true });
    v.addEventListener('canplay', onReady, { once: true });
  };

  // Unlock in touch/click
  document.addEventListener('touchstart', unlockVideos, true);
  document.addEventListener('pointerdown', unlockVideos, true);

  // Mobile/on Observer 
  const isMobile = window.matchMedia('(max-width: 768px)').matches;
  if (isMobile || !('IntersectionObserver' in window)) {
    document.querySelectorAll('.how_to_use_sec video.lazyvid').forEach(loadVid);
    return;
  }

  // IntersectionObserver
  const io = new IntersectionObserver(
    (entries) => entries.forEach((e) => {
      if (!e.isIntersecting) return;
      loadVid(e.target);
      io.unobserve(e.target);
    }),
    { rootMargin: '1200px 0px' }
  );

  document.querySelectorAll('.how_to_use_sec video.lazyvid').forEach(v => io.observe(v));
})();
